<template>
  <div class="container-fluid vertical-spacing">
    <div v-if="products.length" class="row">
      <div
        v-for="product in products"
        :key="product.Id"
        class="col-xs-12 col-sm-6 col-md-3 mb-40"
      >
        <slot :product="product">
          <ProductListItem :product="product" />
        </slot>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-xs">
        {{ $t('No Products in this categoy') }}
        </div>
      </div>
  </div>
</template>

<script>
import ProductListItem from './ProductListItem.vue';

export default {
  name: 'ProductList',
  components: {
    ProductListItem,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.mb-40 {
  margin-bottom: var(--spacer-xl);
}
</style>
